declare var $: any;
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../app/shared/common.service';
import { environment } from '../environments/environment';
import { VisitgridComponent } from './visitgrid/visitgrid.component';
import { AuthenticationService } from './_services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [CommonService],
})

export class AppComponent implements OnInit {
  title = 'AarthiReportPortal';
  toggleClass = 'ft-maximize';
  placement = 'bottom-right';
  public isCollapsed = true;
  public loginPageEnable: boolean = false;
  public welcomeUserName = "";
  public loggedUser = "";
  public iCollapsed: boolean = false;
  public searchText: any;
  public isLogedin: boolean = true;
  public patients: any = [];
  public isHidden : boolean =false;

  // @ViewChild(VisitgridComponent) visit !: VisitgridComponent

  constructor(private router: Router, private route: ActivatedRoute,public authenticationService: AuthenticationService) {
  }

  ngOnInit() {

    if (sessionStorage.getItem("LoginType") != "patient")
    {
      this.welcomeUserName = 'Welcome, ' + sessionStorage.getItem("welcomeUserName");

    }
    if (sessionStorage.getItem("LoginType") == "patient")
    {
      
      this.isHidden=true;
    }


    window.addEventListener('storage', (event) => {
      if (event.storageArea == window.localStorage) {
        let token = window.localStorage.getItem('LogoutUser');
        console.log(token)
        if (token == undefined) {
          // Perform logout
          //Navigate to login/home
          window.location.href = environment.LogoutURL + sessionStorage.getItem('LoginType');
          //this.router.navigate([environment.LogoutURL])+ sessionStorage.getItem('LoginType');
        }
      }
    });
    
  }
  toggle() {

  }
  ToggleClass() {
    if (this.toggleClass === 'ft-maximize') {
      this.toggleClass = 'ft-minimize';
    } else {
      this.toggleClass = 'ft-maximize';
    }
  }

  Logout() {
    $('#Logoutmodal').modal('show');
  }
  fnDashBoard() {
    window.open('/ReportsPortal/#/visitgrid', '_self');
  }
  fnLogout() {
   
    console.clear();
    //window.location.href = environment.LogoutURL + sessionStorage.getItem('LoginType');
    // var logOut_URL=environment.LogoutURL+ sessionStorage.getItem('LoginType');
 
    sessionStorage.setItem('refcode', '');
    sessionStorage.setItem('MobileNo', '');
    sessionStorage.setItem('welcomeUserName', '');
    this.authenticationService.logout()

  }
}
